<template>
  <div class="recruitment-candidates-page">
    <QHeader class="bg-white text-primary shadow-soft">
      <QToolbar>
        <QBtn flat round dense icon="icon-f-arrow-left" @click="goToDashboard()" />
        <QToolbarTitle class="toolbar-subtitled">
          {{ headerTitle }}
          <p>{{ headerSubtitle }}</p>
        </QToolbarTitle>
      </QToolbar>
    </QHeader>
    <ReportCandidateModal v-model:open="reportModalOpened" @refresh="refreshCandidates" />
    <router-view />
  </div>
</template>

<script>
  import { NotificationsManager } from "@core/managers/notifications.manager";
  import { ETAB_ROUTES } from "@etab/config";
  import { GETTER_RECRUITMENT_GET_CURRENT, GETTER_REPORT_MODAL_GET, ACTION_RECRUITMENT_CANDIDATES_GET_DEMAND_CONTACTED } from "@etab/stores/types";
  import { useRecruitmentStore } from "@etab/stores/recruitment";
  import { useRecruitmentCandidatesStore } from "@etab/stores/recruitment-candidates";
  import { useReportCandidateStore } from "@etab/stores/report-candidate";
  import { mapStores } from "pinia";
  import ReportCandidateModal from "@etab/components/recruitments/detail/ReportCandidate.modal.vue";

  export default {
    components: {
      ReportCandidateModal,
    },
    data() {
      return {
        headerTitle: "",
        headerSubtitle: "",
      };
    },
    computed: {
      ...mapStores(useRecruitmentStore, useRecruitmentCandidatesStore, useReportCandidateStore),
      demandId() {
        return this.$route.params.demandId;
      },
      demandType() {
        return this.$route.params.demandType;
      },
      recruitment() {
        return this.recruitmentStore[GETTER_RECRUITMENT_GET_CURRENT];
      },
      reportModalOpened() {
        return this.reportCandidateStore[GETTER_REPORT_MODAL_GET];
      },
    },
    watch: {
      // we watch any change in the url (could be navigation from notification, favorite etc.)
      async demandId() {
        this.inializeTitles();
      },
    },
    mounted() {
      this.$_stopGlobalLoading();
      this.inializeTitles();
    },
    methods: {
      inializeTitles() {
        let headerTitle = "";
        let headerSubtitle = "";

        const qualification = this.recruitment.getQualificationLabel();
        headerSubtitle = this.$t("ETAB.PAGES.RECRUITMENT.@SUBTITLE_QUALIFICATION", { qualification });
        headerTitle = this.$t("ETAB.PAGES.RECRUITMENT.@TITLE_EXPIRED");

        this.headerTitle = headerTitle;
        this.headerSubtitle = headerSubtitle;
      },
      redirectTo(route) {
        if (this.$route.name !== route.name) {
          this.$router.replace(route);
        }
      },
      goToDashboard() {
        if (this.recruitment.hasStarted()) {
          this.$router.push({ name: ETAB_ROUTES.dashboard.tabs.inProgress.name }).catch((suppressedError) => {});
        } else {
          this.$router.push({ name: ETAB_ROUTES.dashboard.tabs.upcoming.name }).catch((suppressedError) => {});
        }
      },
      async refreshCandidates() {
        try {
          this.$_startGlobalLoading();
          await this.recruitmentCandidatesStore[ACTION_RECRUITMENT_CANDIDATES_GET_DEMAND_CONTACTED]({ demandId: this.demandId });
        } catch (error) {
          NotificationsManager.error();
          throw error;
        } finally {
          this.$_stopGlobalLoading();
        }
      },
    },
  };
</script>
